import React from 'react';
import { Link } from 'react-router-dom';
export const PackagesSection = () => {
  const services = [{
    number: '01',
    name: 'Colorful Soft Play Packages',
    description: 'Vibrant and engaging play area perfect for active toddlers',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/m5cwMViJu4F9A84cwxrbnV/77BCF6CB-EA89-44A4-BDDF-18A46698D723-1024x768.jpg',
    imageAlt: 'Colorful soft play setup with fencing and equipment',
    link: '/softplay'
  }, {
    number: '02',
    name: 'Luxury Soft Play Packages',
    description: 'Elegant white-themed soft play setups that add a sophisticated touch to any celebration.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/goXZ8RzqHj1vHnv7UwdHh1/image.png',
    imageAlt: 'White luxury soft play setup with castle bounce house, ball pits, and climbing equipment',
    link: '/luxurysoftplay'
  }, {
    number: '03',
    name: 'Bounce Houses',
    description: 'Colorful and safe inflatable structures designed for endless fun and active play.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sEdbveBY3beGpVKby5Kkr3/image.png',
    imageAlt: 'White bounce house with colorful balls',
    link: '/bouncehouse'
  }];
  return <section id="services" className="bg-white py-12 md:py-20" data-id="element-282">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-283">
        <div className="text-center" data-id="element-284">
          <h3 className="text-sm uppercase font-semibold tracking-wider text-primary-500" data-id="element-285">
            OUR OFFERINGS
          </h3>
          <h2 className="mt-2 text-3xl font-bold text-gray-900" data-id="element-286">
            Explore Our Services
          </h2>
        </div>
        <div className="mt-12 grid grid-cols-1 gap-y-8 gap-x-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-287">
          {services.map(service => <div key={service.name} className="bg-secondary-50 rounded-lg overflow-hidden shadow-md border border-gray-100" data-id="element-288">
              <div className="p-6" data-id="element-289">
                <h3 className="text-4xl font-bold text-primary-500" data-id="element-290">
                  {service.number}
                </h3>
                <h4 className="mt-3 text-xl font-medium text-gray-900" data-id="element-291">
                  {service.name}
                </h4>
                <p className="mt-3 text-base text-gray-500" data-id="element-292">
                  {service.description}
                </p>
              </div>
              <div className="aspect-w-16 aspect-h-9" data-id="element-293">
                <img src={service.image} alt={service.imageAlt} className="w-full h-64 object-cover" data-id="element-294" />
              </div>
              <div className="p-6" data-id="element-295">
                <Link to={service.link} className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-primary-500 hover:bg-primary-600" onClick={() => window.scrollTo(0, 0)} data-id="element-296">
                  LEARN MORE
                </Link>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};